import { useState, useEffect } from 'react';
import { tenantSuspendu } from 'services/api';

/* ⚠️ BANDEAU PERMANENT — « ACCES SUSPENDU », JAMAIS UNE ERREUR MUETTE.
 *    Cas fondateur (01/09/2026) : le bouton « Suspendre » du super-admin
 *    ecrivait un statut que personne ne lisait. Cote client, une suspension ne
 *    produisait donc RIEN — ni blocage, ni message. Le defaut symetrique aurait
 *    ete pire : bloquer les ecritures SANS rien dire, et laisser l'utilisateur
 *    croire a une panne.
 *
 * ⚠️ IL RESTE AFFICHE TANT QUE LA SUSPENSION DURE. Ce n'est pas une alerte
 *    fugace : l'utilisateur doit pouvoir le relire a tout moment pour
 *    comprendre pourquoi ses boutons ne repondent plus. Il disparait SEUL des
 *    qu'une ecriture repasse (reactivation immediate, cf. `services/api.js`).
 *
 * ⚠️ IL N'ANNONCE AUCUNE PERTE DE DONNEES, parce qu'il n'y en a aucune : une
 *    suspension ne supprime ni n'altere rien. Le dire explicitement evite la
 *    panique et le ticket de support qui va avec.
 */
export default function BandeauSuspension() {
  const [message, setMessage] = useState(tenantSuspendu());

  useEffect(() => {
    const onSuspendu = (e) => setMessage(e.detail?.message || 'Acces suspendu — contactez votre fournisseur.');
    const onReactive = () => setMessage(null);
    window.addEventListener('gss:tenant-suspendu', onSuspendu);
    window.addEventListener('gss:tenant-reactive', onReactive);
    return () => {
      window.removeEventListener('gss:tenant-suspendu', onSuspendu);
      window.removeEventListener('gss:tenant-reactive', onReactive);
    };
  }, []);

  if (!message) return null;

  return (
    <div role="status" data-testid="bandeau-suspension" style={{
      background: '#7F1D1D', color: '#FFF', padding: '10px 20px',
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      fontSize: 13.5, lineHeight: 1.5,
    }}>
      <span style={{ fontSize: 18, lineHeight: 1 }} aria-hidden="true">⛔</span>
      <span><strong>{message}</strong></span>
      <span style={{ color: '#FCA5A5', fontSize: 12.5 }}>
        Vous pouvez toujours consulter toutes vos données — elles sont intactes.
        Seules les créations et modifications sont bloquées.
      </span>
    </div>
  );
}
